import { uiToast } from '../ui/component/toast';
import { $el } from '../ui/elements';
import { UIClassesSpec } from '../ui/types';
import { UIView, UIViewSpec } from '../ui/view';
import { $clip, YClipObject } from '../y/clip';
import { YEventHandlers, YStateEvent, YInputEvent, YValueEvent } from '../y/events';
import { YForm } from '../y/form';
import { EDBlock } from './block';
import { EDBlockList } from './blocklist';
import { EDBlockContainer, EDEditor, EDButtonSpec } from './editor';

export abstract class EDSection<Section, Block extends { type: string }, Extra extends {} = {}> extends UIView implements EDBlockContainer<Extra> {
    protected list: EDBlockList<Block, Extra>
    form: YForm;

    $handlers: YEventHandlers<YStateEvent & YInputEvent & YValueEvent<Section>>;

    has_selection?: boolean;
    properties: UIViewSpec;
    parent: EDEditor<Section, Block, Extra> & Extra;
    editor: EDEditor<Section, Block, Extra> & Extra;
    name: string;
    order_handle: HTMLElement;
    auto_expand: boolean;
    doRemove?: () => void;

    constructor(form: YForm, parent: EDEditor<Section, Block, Extra> & Extra, properties: UIViewSpec, classes?: UIClassesSpec) {
        super('section', ['ed-section ed-object ui-section', classes]);
        this.ui_elem.ed_object = this;

        this.parent = parent;
        this.editor = parent;
        this.name = 'Section';
        this.auto_expand = true;

        this.root.addEventListener('click', e => {
            parent.selectObject(this);
            e.stopPropagation();
        });

        this.list = new EDBlockList(parent, b => parent.makeBlock(b, this));

        form.add('blocks', this.list.blocks);
        this.form = form;
        this.properties = properties;

        this.ui_add([
            this.order_handle = $el.DIV('ed-order u-handle'),
            this.list,
        ]);
    }

    getButtons(): EDButtonSpec[] {
        return this.list.getButtons();
    }

    getChildButtons(block: EDBlock<Extra>): EDButtonSpec[] {
        return this.list.getButtons(block);
    }

    insertBlock(rel: EDBlock<Extra> | undefined, anchor: UIViewSpec) {
        return this.list.insertBlock(rel, anchor);
    }

    removeBlock(block: EDBlock<Extra>) {
        return this.list.removeBlock(block);
    }

    get children() {
        return this.list.blocks.views;
    }

    get selection_style() {
        return { offset: 0, radius: 0, thickness: 5 };
    }

    get hover_style() {
        return { offset: 0, radius: 0, thickness: 3 };
    }

    doCopy(): void {
        const value = this.form.value;
        value.id = undefined;
        $clip.writeObject('ed-section', value).then(() => { uiToast('Section copied to clipboard') });
    }

    doPaste(object: YClipObject, editor_block?: EDBlock<Extra>): void {
        if(object[0] == 'ed-block') {
            const blocks = this.list.blocks;
            const entry = blocks.insertBefore(object[1], editor_block && blocks.findView(editor_block));
            this.editor.selectObject(entry?.view);
        } else {
            this.parent.doPaste(object, this);
        }
    }
}
